"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheckerMessaging = require("../../../constants/ReadinessCheckerMessaging");
var _Styling = require("./Styling");
var ReadinessCheckerMessaging = function ReadinessCheckerMessaging(_ref) {
  var name = _ref.name;
  var data = _ReadinessCheckerMessaging.ReadinessCheckerMessagingMap[name];
  if (!data) return null;
  var title = data.title,
    content = data.content,
    learnMoreLink = data.learnMoreLink,
    _data$urls = data.urls,
    urls = _data$urls === void 0 ? [] : _data$urls;
  var Component = name === _ReadinessCheckerMessaging.NETWORK_TRAFFIC_ERROR ? _Styling.CopyToClipboardStyling : _Styling.DefaultStyling;
  return _react["default"].createElement(Component, {
    title: title,
    content: content,
    learnMoreLink: learnMoreLink,
    urls: urls
  });
};
ReadinessCheckerMessaging.propTypes = {
  name: _propTypes.string
};
var _default = exports["default"] = ReadinessCheckerMessaging;